/**
 * Labels of the bulk-action bar (`./ActionBar.tsx`) in en / fr / es. Also read by
 * `components/Checkout/ExpressCheckout/QuoteCheckoutActionBar/QuoteCheckoutActionBar.tsx` for its
 * mobile "Unselect All" item. `selected` is the English word in all three languages.
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Label keys of the action bar. `product` / `products` follow the selected count (1 vs more). */
export type ActionBarContentProps = {
	unselectAll: string;
	selected: string;
	product: string;
	products: string;
	moreTools: string;
};

/** Action bar labels by language. */
export const ActionBarContent: LanguageContent<ActionBarContentProps> = {
	en: {
		unselectAll: "Unselect All",
		selected: "Selected",
		product: "product",
		products: "products",
		moreTools: "More Tools",
	},
	fr: {
		unselectAll: "Désélectionner tout",
		selected: "Selected",
		product: "Produit",
		products: "produits",
		moreTools: "Plus d'outils",
	},
	es: {
		unselectAll: "Deseleccionar todo",
		selected: "Selected",
		product: "Producto",
		products: "productos",
		moreTools: "Más herramientas",
	},
};
